import type { inferOutput } from "@trpc/tanstack-react-query";
import type { trpc } from "../../app/trpc.js";

export type OnboardingState = inferOutput<typeof trpc.onboarding.state>;
export type StepId = OnboardingState["step"];
export type DraftService = NonNullable<OnboardingState["servicesDraft"]>[number];
/** Ответы на вопросы о правилах, найденные в источниках владельца (`onboarding.state.answersDraft`). */
export type AnswersDraft = NonNullable<OnboardingState["answersDraft"]>;
export type QuestionView = OnboardingState["questions"][number];

/** Шаги мастера настройки по порядку (как `StepIds` на сервере). */
export const STEPS: readonly StepId[] = ["template", "services", "masters", "rules", "assistant", "bookings", "test", "instagram", "done"];

export interface StepProps {
  salonId: string;
  state: OnboardingState;
  /** Перейти к следующему шагу (текущий отмечается пройденным); при несохранённых правках спросит подтверждение, кроме `saved: true`. */
  next: (opts?: { saved?: boolean }) => void;
  /** Назад на предыдущий шаг (с первого: в «Ещё»); при несохранённых правках спросит подтверждение, кроме `saved: true`. */
  back: (opts?: { saved?: boolean }) => void;
  /** Обновить состояние мастера в кэше (ответ мутаций `onboarding.*`). */
  setState: (s: OnboardingState) => void;
}
